var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Routes, Route } from "react-router-dom";
import { useMemo } from "react";
import { appRoutes } from "./routes";
import { ProtectedRoute } from "./ProtectedRoute";
export var RouterManager = function () {
    var routes = useMemo(function () {
        return appRoutes.map(function (_a) {
            var allowedRoles = _a.allowedRoles, path = _a.path, Component = _a.Component;
            var element = allowedRoles ? (_jsx(ProtectedRoute, __assign({ allowedRoles: allowedRoles }, { children: _jsx(Component, {}) }))) : (_jsx(Component, {}));
            return _jsx(Route, { path: path, element: element }, path);
        });
    }, []);
    return _jsx(Routes, { children: routes });
};
